export const discover = [
  {
    name: 'Paysage montagneux et desert',
    img: './img/home/img_1.webp',
    alt: 'SeedOut fenua paysage montagneux et desertique'
  },
  {
    name: 'Santuaire en 3D',
    img: './img/home/img_2.webp',
    alt: 'SeedOut fenua modélisation d\'un sanctuaire en 3D'
  },
  {
    name: 'Dessin d\'un santuaire',
    img: './img/home/img_3.webp',
    alt: 'SeedOut fenua paysage montrant un sanctuaire'
  },
  {
    name: 'Irrigation et reforestation',
    img: './img/home/img_4.webp',
    alt: 'SeedOut fenua carte d\'irrigation et de refosrestation'
  },
  {
    name: 'Modélisation 3D de la faune et de la flore',
    img: './img/home/img_5.webp',
    alt: 'SeedOut fenua modélisation de la faune et de la flore en 3D'
  },
  {
    name: 'Mécanisme du système d\'irrigation',
    img: './img/home/img_6.webp',
    alt: 'SeedOut fenua demonstration du système d\'irrigation et de refosrestation'
  },
];

export const guardians = [
  {
    name: 'L\'explorateur',
    title: 'Gardien Explorateur',
    desc: 'Aventureux et aimant prendre des risques, l\'explorateur déniche mieux que quiconque les trésors enfouis dans le coeur de la forêt.',
    img: './img/home/gardien_explorateur.webp',
    alt: 'seedout fenua image du gardien explorateur'
  },
  {
    name: 'Le botaniste',
    title: 'Gardien Botaniste',
    desc: 'Doté d\'une connaissance hors pair de la faune et de la flore. Toujours prêt à rendre service, le botaniste connaît la forêt mieux que personne.',
    img: './img/home/gardien_botaniste.webp',
    alt: 'seedout fenua image du gardien botaniste'
  },
  {
    name: 'Le batisseur',
    title: 'Gardien Batisseur',
    desc: 'Aventureux et aimant prendre des risques, l\'explorateur déniche mieux que quiconque les trésors enfouis dans le coeur de la forêt.',
    img: './img/home/gardien_batisseur.webp',
    alt: 'seedout fenua image du gardien batisseur'
  }
];

export const preface = {
  title: 'Gardien au milieu d\'un paysage désertique',
  img: './img/home/guardian_desert.webp',
  alt: 'Gardien au milieu d\'un paysage désertique'
}

export const registerSupport = [
  {
    alt: 'Image SeedOut Fenua Autodesk Maya',
    img: './img/home/support_seedout_1.webp',
    title: 'SeedOut Autodesk Maya'
  },
  {
    alt: 'Image soutenir SeedOut Fenua',
    img: './img/home/support_seedout_2.webp',
    title: 'Soutenir SeedOut Fenua'
  }
];
